import React, { Children, cloneElement } from "react";
import classNames from "classnames";
import { RiArrowDropLeftLine, RiCloseFill } from "react-icons/ri";

import Icon from "../icon/Icon.jsx";
import "./styles.styl";

export function Tabs(props) {
  const {
    className,
    activeIndex,
    colorprimary,
    onTabClick,
    onCloseOrBack,
    onChange,
    visitedFromCart,
    ...rest
  } = props;
  const children = Children.toArray(rest.children);
  const TabLinks = children.map((c, i) => {
    return (
      <Tab key={i} {...c.props} children={null} onClick={() => onTabClick(i)} />
    );
  });
  const isActive = activeIndex !== undefined;
  const activeTab = isActive ? children[activeIndex].props : {};
  return (
    <div
      className={classNames(
        "settings-tabs",
        { "is-active": isActive },
        className,
      )}
    >
      {activeTab.name && (
        <div className="setting-banner-wrapper setting_wrapper ">
          <div
            className={
              (isActive && visitedFromCart) || !isActive
                ? "settings__close"
                : "settings__back"
            }
            onClick={onCloseOrBack}
          >
            {(isActive && visitedFromCart) || !isActive ? (
              <RiCloseFill size={35} color={"white"} />
            ) : (
              <RiArrowDropLeftLine size={40} color={"white"} />
            )}
          </div>
          <div className="settings-tabs__head" onClick={onCloseOrBack}>
            {activeTab.name}
          </div>
        </div>
      )}
      <div
        className={classNames("settings-tabs__inner", {
          "settings-tabs__full-height": isActive,
        })}
      >
        <div className="settings-tabs__tabs">{TabLinks}</div>
        <div className="settings-tabs__content">
          <div className="settings-tabs__content__inner">
            {activeTab.children}
          </div>
        </div>
      </div>
    </div>
  );
}

export function Tab(props) {
  const { className, icon, name, onClick, displayed = true, ...rest } = props;
  const onLocalClick = () => {
    return displayed ? onClick() : null;
  };
  return (
    <a
      className={classNames("settings-tab", {
        ...className,
        "settings-tab__is-disabled": !displayed,
      })}
      onClick={onLocalClick}
    >
      <div
        className={classNames("settings-tab__link", {
          ...className,
          "settings-tab__link-is-disabled": !displayed,
        })}
      >
        <Icon className="settings-tab__link__icon" name={icon} />
        <p className="settings-tab__link__name">{name}</p>
        {displayed && (
          <Icon className="settings-tab__link__arrow" name="arrow-right" />
        )}
      </div>
    </a>
  );
}
